module.exports = __webpack_public_path__ + "static/media/toolsIcon.141935d6.svg";